<template>
   <div>
       <div class="container-fluid">
           <div class="management-services-header">
               <div id="ms-header-bg"></div>
               <!-- <div id="header-gDash"></div> -->
               <div class="header-text">
                   <p>
                   High Quality Products<br> 
                   Delivered to your <br>
                   Destination.<br>
                   </p>
               </div>
           </div>
           <div class="mobile-img-header">
               <div>
                   <div style="background-image:url('../../public/images/products.jpg');background-size:cover;background-repeat:no-repeat;width:100%;height:0;padding-top:52vh;position:relative;"></div>
                   <div class="mobile-header-text">
                       <p>
                            High Quality Products<br> 
                            Delivered to your <br>
                            Destination.<br>
                        </p>
                   </div>
               </div>
           </div>
       </div>
       <div class="container-fluid cont">
           <div class="product-content1">
               <!-- <div class="products-page-sidenav">
                   <p @click="ShowFittings()" v-bind:class="{'active-tab': showFittings}">Fittings</p>
                   <p @click="ShowFlanges()" v-bind:class="{'active-tab': showFlanges}">Flanges</p>
                   <p @click="ShowForgings()" v-bind:class="{'active-tab': showForgings}">Forgings (Custom Made)</p>
                   <p @click="ShowHeads()" v-bind:class="{'active-tab': showHeads}">Heads</p>
                   <p @click="ShowBoltings()" v-bind:class="{'active-tab': showBoltings}">Boltings</p>
                   <p @click="ShowTubesheets()" v-bind:class="{'active-tab': showTubesheets}">Tubesheets</p>
                   <p @click="ShowGallery()" v-bind:class="{'active-tab': showGallery}">Product Gallery</p>
               </div>
               <div class="dropdown" >
                       <button class="btn btn-secondary dropdown-toggle section-select" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                           <p style="display:contents;" v-if="showFittings">Fittings</p>
                           <p style="display:contents;" v-if="showFlanges">Flanges</p>
                           <p style="display:contents;" v-if="showForgings">Forgings (Custom Made)</p>
                           <p style="display:contents;" v-if="showHeads">Heads</p>
                           <p style="display:contents;" v-if="showBoltings">Boltings</p>
                           <p style="display:contents;" v-if="showTubesheets">Tubesheets</p>
                           <p style="display:contents;" v-if="showGallery">Product Gallery</p>
                       </button>
                       <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="width:100%;border-radius:0px;">
                           <a class="dropdown-item" href="#" style="padding:12px 15px;" @click="ShowFittings()">Fittings</a>
                           <a class="dropdown-item" href="#" style="padding:12px 15px;" @click="ShowFlanges()">Flanges</a>
                           <a class="dropdown-item" href="#" style="padding:12px 15px;" @click="ShowForgings()">Forgings (Custom Made)</a>
                           <a class="dropdown-item" href="#" style="padding:12px 15px;" @click="ShowHeads()">Heads</a>
                           <a class="dropdown-item" href="#" style="padding:12px 15px;" @click="ShowBoltings()">Boltings</a>
                           <a class="dropdown-item" href="#" style="padding:12px 15px;" @click="ShowTubesheets()">Tubesheets</a>
                           <a class="dropdown-item" href="#" style="padding:12px 15px;" @click="ShowGallery()">Product Gallery</a>
                       </div>
                   </div> -->
               <!-- <div id="mobile-line"></div> -->

                <!-- New Layout -->

               <!-- <h2 class="product-content-title">Fittings</h2> -->

               <div class="products-content-right products-gallery-section">
                   <h2 class="product-content-title">Product Catalog</h2>
                   <div role="tablist">
                       <b-card no-body class="mb-1 asm" @click="PGallFlanges()">
                           <router-link to="/flanges" style="text-decoration:none;">
                           <b-button block v-b-toggle.accordion-2 variant="#004884" class="accordion-tab" v-bind:class="{'tab-select': gallFlanges}">
                               <p>Flanges</p>
                               <svg class="btn-svg" height="48" width="48" xmlns="http://www.w3.org/2000/svg" v-bind:class="{'sel-btn-svg': gallFlanges}">
                                   <path d="m 15 19 l 9 9 l 9 -9 l -18 0 z"/>
                                   <path d="M0-.25h24v24H0z" fill="none"/>
                               </svg>
                           </b-button>
                           </router-link>
                           <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel">
                               <b-card-body>
                                   <b-card-text class="accordion-text" style="margin-top:-15px;display:flex;flex-direction:column;">
                                       <div class="content-info-box">
                           <div class="content-box-row">
                               <p class="content-box-row-header">Flanges</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Welding Neck</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Slip On Flange</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Blind</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Long Welding Neck</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Orifice Flange</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Nozzle Neck</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Shell/Channel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Weldo/Nipo</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Square</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Spectacle</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Flange Plate</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Stub End</div>
                           </div> 
                           <div class="content-box-row">
                               <p class="content-box-row-header">Standards</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>ANSI B 16.5, B16.47</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>MSS-SP-44</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>API</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>ASTM</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Materials</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Low Temp Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>High Yield Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Stainless Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Alloy Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Duplex</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Production Range</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>B16.5 1/2"-24"</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>B16.47 SERIES A &amp; B 26"-60"</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Custom Sizes</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Max Diameter: 6m</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Max Height: 1m</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Max Weight: 110 Ton</div>
                           </div>
                       </div>
                                       <div class="product-gallery-row">
                                           <div class="product-gallery-img" v-for="(record, i)  in fFlanges" :key="record.id">
                                               <lightbox :thumbnail="record.fields.Image[0].url" :images="fFlanges" :name="fFlanges" :num="i"/>
                                               <div class="product-gallery-row-title">{{ record.fields.Product }}</div>
                                           </div>
                                       </div>
                                   </b-card-text>
                               </b-card-body>
                           </b-collapse>
                       </b-card>

                       <b-card no-body class="mb-1 asm" @click="PGallForgings()">
                           <router-link to="/forgings" style="text-decoration:none;">
                           <b-button block v-b-toggle.accordion-3 variant="#004884" class="accordion-tab" v-bind:class="{'tab-select': gallForgings}">
                               <p>Forgings (Custom Made)</p>
                               <svg class="btn-svg" height="48" width="48" xmlns="http://www.w3.org/2000/svg" v-bind:class="{'sel-btn-svg': gallForgings}">
                                   <path d="m 15 19 l 9 9 l 9 -9 l -18 0 z"/>
                                   <path d="M0-.25h24v24H0z" fill="none"/>
                               </svg>
                           </b-button>
                           </router-link>
                           <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                               <b-card-body>
                                   <b-card-text class="accordion-text" style="margin-top:-15px;display:flex;flex-direction:column;">
                                       <div class="content-info-box">
                           <div class="content-box-row">
                               <p class="content-box-row-header">Forgings (Custom Made)</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Body Flange</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Girth Flange</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Blinds</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Channel Covers</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Rings</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Custom Made</div>
                           </div>
                           <div class="content-box-row" >
                               <p class="content-box-row-header">Standards</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>ASTM</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>ASME</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>API</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Materials</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Low Temp Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>High Yield Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Stainless Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Alloy Steel</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Production Range</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>B16.5 1/2"-24"</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>B16.47 SERIES A &amp; B 26"-60"</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Max Diameter: 9m</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Max Height: 3m</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Max Weight: 300 Ton</div>
                           </div>
                       </div>
                                        <div class="product-gallery-row">
                                           <div class="product-gallery-img" v-for="(record, i) in fForgings" :key="record.id">
                                               <lightbox :thumbnail="record.fields.Image[0].url" :images="fForgings" :name="fForgings" :num="i"/>
                                               <div class="product-gallery-row-title">{{ record.fields.Product }}</div>
                                           </div>
                                       </div>
                                   </b-card-text>
                               </b-card-body>
                           </b-collapse>
                       </b-card>

                       <b-card no-body class="mb-1 asm" @click="PGallTubesheets()">
                           <router-link to="/tubesheets" style="text-decoration:none;">
                               <b-button block v-b-toggle.accordion-6 variant="#004884" class="accordion-tab" v-bind:class="{'tab-select': gallTubesheets}">
                                   <p>Tubesheets</p>
                                   <svg class="btn-svg" height="48" width="48" xmlns="http://www.w3.org/2000/svg" v-bind:class="{'sel-btn-svg': gallTubesheets}">
                                       <path d="m 15 19 l 9 9 l 9 -9 l -18 0 z"/>
                                       <path d="M0-.25h24v24H0z" fill="none"/>
                                   </svg>
                               </b-button>
                           </router-link>
                           <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                               <b-card-body>
                                   <b-card-text class="accordion-text" style="margin-top:-15px;display:flex;flex-direction:column;">
                                       <div class="content-info-box">
                           <div class="content-box-row">
                               <p class="content-box-row-header">Tubesheets</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Custom Made</div>
                           </div>
                           <div class="content-box-row" >
                               <p class="content-box-row-header">Standards</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>ASTM</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>ASME</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>API</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Materials</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Low Temp Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>High Yield Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Stainless Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Alloy Steel</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Production Range</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>B16.5 1/2"-24"</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>B16.47 SERIES A &amp; B 26"-60"</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Max Diameter: 6m</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Max Height: 1m</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Max Weight: 110 Ton</div>
                           </div>
                       </div>
                                       <div class="product-gallery-row">
                                           <div class="product-gallery-img" v-for="(record, i) in fTubesheets" :key="record.id">
                                               <lightbox :thumbnail="record.fields.Image[0].url" :images="fTubesheets" :name="fTubesheets" :num="i"/>
                                               <div class="product-gallery-row-title">{{ record.fields.Product }}</div>
                                           </div>
                                       </div>
                                   </b-card-text>
                               </b-card-body>
                           </b-collapse>
                       </b-card>

                       <b-card no-body class="mb-1 asm" @click="PGallHeads()">
                           <router-link to="/heads" style="text-decoration:none;">
                           <b-button block v-b-toggle.accordion-4 variant="#004884" class="accordion-tab" v-bind:class="{'tab-select': gallHeads}">
                               <p>Heads</p>
                               <svg class="btn-svg" height="48" width="48" xmlns="http://www.w3.org/2000/svg" v-bind:class="{'sel-btn-svg': gallHeads}">
                                   <path d="m 15 19 l 9 9 l 9 -9 l -18 0 z"/>
                                   <path d="M0-.25h24v24H0z" fill="none"/>
                               </svg>   
                           </b-button>
                           </router-link>
                           <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                               <b-card-body>
                                   <b-card-text class="accordion-text" style="margin-top:-15px;display:flex;flex-direction:column;">
                                       <div class="content-info-box">
                           <div class="content-box-row">
                               <p class="content-box-row-header">Heads</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>2:1 Elliptical</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Hemispherical</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Standards</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>ASME SEC. VIII DIV.1 &amp; DIV. II</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Materials</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Stainless Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Duplex</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Production Range</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>10’ ~ 25’ Diameter</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>1.5” ~ 5” Thickness</div>
                           </div>
                       </div>
                                       <div class="product-gallery-row">
                                           <div class="product-gallery-img" v-for="(record, i) in fHeads" :key="record.id">
                                               <lightbox :thumbnail="record.fields.Image[0].url" :images="fHeads" :name="fHeads" :num="i"/>
                                               <div class="product-gallery-row-title">{{ record.fields.Product }}</div>
                                           </div>
                                       </div>
                                   </b-card-text>
                               </b-card-body>
                           </b-collapse>
                       </b-card>

                       <b-card no-body class="mb-1 asm" @click="PGallFittings()">
                           <router-link to="/fittings" style="text-decoration:none;">
                               <b-button block v-b-toggle.accordion-1 variant="#004884" class="accordion-tab" v-bind:class="{'tab-select': gallFittings}">
                                   <p>Fittings</p>
                                   <svg class="btn-svg" height="48" width="48" xmlns="http://www.w3.org/2000/svg" v-bind:class="{'sel-btn-svg': gallFittings}">
                                       <path d="m 15 19 l 9 9 l 9 -9 l -18 0 z"/>
                                       <path d="M0-.25h24v24H0z" fill="none"/>
                                   </svg>
                               </b-button>
                           </router-link>
                           <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                               <b-card-body>
                                   <b-card-text class="accordion-text" style="margin-top:-15px;display:flex;flex-direction:column;">
                                       <div class="content-info-box">
                           <div class="content-box-row" >
                               <p class="content-box-row-header">Fittings</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Elbow</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Tee</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Pipe Reducer</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Cap</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Stub-End</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Bends (3D/5D/8D)</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Reducer Coupling</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Pipe Reducer</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Butt Weld Fittings</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Standards</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>ANSI B16.25</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>MSS SP-42, 75</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>ASTM</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Materials</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Low Temp Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>High Yield Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Stainless Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Alloy Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Duplex</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Production Range</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>2” ˜ 24” (Seamless)</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>26” ˜ 60” (Welded)</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>64” ˜ 120” (Welded)</div>
                           </div>
                       </div>
                                       <div class="product-gallery-row">
                                           <div class="product-gallery-img" v-for="(record, i) in fFittings" :key="record.id">
                                               <lightbox :thumbnail="record.fields.Image[0].url" :images="fFittings" :name="fFittings" :num="i"/>
                                               <div class="product-gallery-row-title">{{ record.fields.Product }}</div>
                                           </div>
                                       </div>
                                   </b-card-text>
                               </b-card-body>
                           </b-collapse>
                       </b-card>
 
                       <b-card no-body class="mb-1 asm" @click="PGallBoltings()">
                           <router-link to="/boltings" style="text-decoration:none;">
                           <b-button block v-b-toggle.accordion-5 variant="#004884" class="accordion-tab" v-bind:class="{'tab-select': gallBoltings}">
                               <p>Boltings</p>
                               <svg class="btn-svg" height="48" width="48" xmlns="http://www.w3.org/2000/svg" v-bind:class="{'sel-btn-svg': gallBoltings}">
                                   <path d="m 15 19 l 9 9 l 9 -9 l -18 0 z"/>
                                   <path d="M0-.25h24v24H0z" fill="none"/>
                               </svg>
                           </b-button>
                           </router-link>
                           <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                               <b-card-body>
                                   <b-card-text class="accordion-text" style="margin-top:-15px;display:flex;flex-direction:column;">
                                       <div class="content-info-box">
                           <div class="content-box-row">
                               <p class="content-box-row-header">Boltings</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Stud Bolt / Hex Nut</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Heavy Hex Bolt / Hex Nut</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Standards</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>ASTM</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>ASME</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>ISO</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>ANSI</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>UNS</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Materials</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Carbon Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Stainless Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Alloy Steel</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Nickel Alloys</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Duplex</div>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>Titanium</div>
                           </div>
                           <div class="content-box-row">
                               <p class="content-box-row-header">Production Range</p>
                               <div class="product-point"><div class="pp-inner"><div class="gsquare"></div></div>½” ~ 7”</div>
                           </div>
                       </div>
                                       <div class="product-gallery-row">
                                           <div class="product-gallery-img" v-for="(record, i) in fBoltings" :key="record.id">
                                               <lightbox :thumbnail="record.fields.Image[0].url" :images="fBoltings" :name="fBoltings" :num="i"/>
                                               <div class="product-gallery-row-title">{{ record.fields.Product }}</div>
                                           </div>
                                       </div>
                                   </b-card-text>
                               </b-card-body>
                           </b-collapse>
                       </b-card>
                   </div>
               </div>



                <!-- Old Layout -->
    
               <!-- Fittings Section -->
               <!-- <div class="products-content-right" style="float: left;" v-if="showFittings">
                   <div class="products-gallery" >
                       <div class="products-car">
                           <div id="fittings-car" class="carousel carousel-fade" data-ride="carousel" style="width: 100%; height: 100%; display: block; margin: 0 0 8% 4%; float: right;">
                               <ol class="carousel-indicators">
                                   <li data-target="#fittings-car" data-slide-to="0" class="active"></li>
                                   <li data-target="#fittings-car" data-slide-to="1"></li>
                               </ol>
                               <div class="carousel-inner">
                                   <div class="carousel-item active">
                                       <img class="d-block w-100" src="../../public/images/FittingsP1.jpg" alt="First slide">
                                   </div>
                                   <div class="carousel-item">
                                       <img class="d-block w-100" src="../../public/images/FittingsP2.jpg" alt="Second slide">
                                   </div>
                               </div>
                               <a class="carousel-control-prev" href="#fittings-car" role="button" data-slide="prev">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-back-circle.svg" style="width: 30px;"></span>
                                   <span class="sr-only">Previous</span>
                               </a>
                               <a class="carousel-control-next" href="#fittings-car" role="button" data-slide="next">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-forward-circle.svg" style="width: 30px;"></span>
                                   <span class="sr-only">Next</span>
                               </a>
                           </div>
                           <div class="clearfix"></div>
                       </div>
                   </div>
                   <div class="content-info">
                       <h2 class="product-content-title">Fittings</h2>
                       <div class="content-info-box">
                           <div class="content-box-row" >
                               <p class="content-box-row-header">Fittings</p>
                               <div class="product-point"><div class="gsquare"></div>Elbow</div>
                               <div class="product-point"><div class="gsquare"></div>Tee</div>
                               <div class="product-point"><div class="gsquare"></div>Reducer</div>
                               <div class="product-point"><div class="gsquare"></div>Cap</div>
                               <div class="product-point"><div class="gsquare"></div>Stub-End</div>
                               <div class="product-point"><div class="gsquare"></div>Bends (3D/5D/8D)</div>
                           </div>
                           <div class="content-box-row cbr2">
                               <p class="content-box-row-header">Standards</p>
                               <div class="product-point"><div class="gsquare"></div>ANSI B16.25</div>
                               <div class="product-point"><div class="gsquare"></div>MSS SP-42, 75</div>
                               <div class="product-point"><div class="gsquare"></div>JIS</div>
                               <div class="product-point"><div class="gsquare"></div>BS</div>
                           </div>
                           <div class="clearfix"></div>
                           <div class="content-box-row cbr3">
                               <p class="content-box-row-header">Materials</p>
                               <div class="product-point"><div class="gsquare"></div>Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Low Temp Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>High Yield Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Stainless Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Alloy Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Duplex</div>
                           </div>
                           <div class="content-box-row cbr4">
                               <p class="content-box-row-header">Production Range</p>
                               <div class="product-point"><div class="gsquare"></div>2” ˜ 24” (Seamless)</div>
                               <div class="product-point"><div class="gsquare"></div>26” ˜ 60” (Welded)</div>
                               <div class="product-point"><div class="gsquare"></div>64” ˜ 120” (Welded)</div>
                           </div>
                       </div>
                   </div>
               </div> -->
 
               <!-- Flanges Section -->
               <!-- <div class="products-content-right" style="float: left;" v-if="showFlanges">
                   <div class="products-gallery" >
                       <div class="products-car">
                           <div id="flanges-car" class="carousel carousel-fade" data-ride="carousel" style="width: 100%; height: 100%; display: block; margin: 0 0 8% 4%; float: right;">
                               <ol class="carousel-indicators">
                                   <li data-target="#flanges-car" data-slide-to="0" class="active"></li>
                                   <li data-target="#flanges-car" data-slide-to="1"></li>
                               </ol>
                               <div class="carousel-inner">
                                   <div class="carousel-item active">
                                       <img class="d-block w-100" src="../../public/images/FlangesP1.jpg" alt="First slide">
                                   </div>
                                   <div class="carousel-item">
                                       <img class="d-block w-100" src="../../public/images/FlangesP2.jpg" alt="Second slide">
                                   </div>
                               </div>
                               <a class="carousel-control-prev" href="#flanges-car" role="button" data-slide="prev">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-back-circle.svg" style="width: 30px;"></span>
                                   <span class="sr-only">Previous</span>
                               </a>
                               <a class="carousel-control-next" href="#flanges-car" role="button" data-slide="next">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-forward-circle.svg" style="width: 30px;"></span>
                                   <span class="sr-only">Next</span>
                               </a>
                           </div>
                           <div class="clearfix"></div>
                       </div>
                   </div>
                   <div class="content-info">
                       <h2 class="product-content-title">Flanges</h2>
                       <div class="content-info-box">
                           <div class="content-box-row">
                               <p class="content-box-row-header">Flanges</p>
                               <div class="product-point"><div class="gsquare"></div>Welding Neck</div>
                               <div class="product-point"><div class="gsquare"></div>Slip On</div>
                               <div class="product-point"><div class="gsquare"></div>Blind</div>
                               <div class="product-point"><div class="gsquare"></div>Long Welding Neck</div>
                               <div class="product-point"><div class="gsquare"></div>Orifice</div>
                               <div class="product-point"><div class="gsquare"></div>Nozzle Neck</div>
                               <div class="product-point"><div class="gsquare"></div>Shell/Channel</div>
                               <div class="product-point"><div class="gsquare"></div>Weldo/Nipo</div>
                               <div class="product-point"><div class="gsquare"></div>Square</div>
                               <div class="product-point"><div class="gsquare"></div>Spectacle</div>
                           </div>
                           <div class="content-box-row cbr2">
                               <p class="content-box-row-header">Standards</p>
                               <div class="product-point"><div class="gsquare"></div>ANSI B 16.5, B16.47</div>
                               <div class="product-point"><div class="gsquare"></div>MSS-SP-44</div>
                               <div class="product-point"><div class="gsquare"></div>API</div>
                               <div class="product-point"><div class="gsquare"></div>JIS</div>
                               <div class="product-point"><div class="gsquare"></div>BS</div>
                               <div class="product-point"><div class="gsquare"></div>DIN</div>
                           </div>
                           <div class="clearfix"></div>
                           <div class="content-box-row cbr3">
                               <p class="content-box-row-header">Materials</p>
                               <div class="product-point"><div class="gsquare"></div>Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Low Temp Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>High Yield Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Stainless Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Alloy Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Duplex</div>
                           </div>
                           <div class="content-box-row cbr4">
                               <p class="content-box-row-header">Production Range</p>
                               <div class="product-point"><div class="gsquare"></div>B16.5 1/2"-24"</div>
                               <div class="product-point"><div class="gsquare"></div>B16.47 SERIES A &amp; B 26"-60"</div>
                           </div>
                       </div>
                   </div>
               </div> -->
 
               <!-- Forgings Section -->
               <!-- <div class="products-content-right" style="float: left;" v-if="showForgings">
                   <div class="products-gallery" >
                       <div class="products-car">
                           <div id="forgings-car" class="carousel carousel-fade" data-ride="carousel" style="width: 100%; height: 100%; display: block; margin: 0 0 8% 4%; float: right;">
                               <ol class="carousel-indicators">
                                   <li data-target="#forgings-car" data-slide-to="0" class="active"></li>
                                   <li data-target="#forgings-car" data-slide-to="1"></li>
                               </ol>
                               <div class="carousel-inner">
                                   <div class="carousel-item active">
                                       <img class="d-block w-100" src="../../public/images/ForgingsP1.jpg" alt="First slide">
                                   </div>
                                   <div class="carousel-item">
                                       <img class="d-block w-100" src="../../public/images/ForgingsP2.jpg" alt="Second slide">
                                   </div>
                               </div>
                               <a class="carousel-control-prev" href="#forgings-car" role="button" data-slide="prev">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-back-circle.svg" style="width: 30px;"></span>
                                   <span class="sr-only">Previous</span>
                               </a>
                               <a class="carousel-control-next" href="#forgings-car" role="button" data-slide="next">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-forward-circle.svg" style="width: 30px;"></span>
                                   <span class="sr-only">Next</span>
                               </a>
                           </div>
                           <div class="clearfix"></div>
                       </div>
                   </div>
                   <div class="content-info">
                       <h2 class="product-content-title">Forgings (Custom Made)</h2>
                       <div class="content-info-box">
                           <div class="content-box-row">
                               <p class="content-box-row-header">Forgings (Custom Made)</p>
                               <div class="product-point"><div class="gsquare"></div>Tube Sheet</div>
                               <div class="product-point"><div class="gsquare"></div>Nozzle Neck</div>
                               <div class="product-point"><div class="gsquare"></div>Shaft</div>
                               <div class="product-point"><div class="gsquare"></div>Piston Rod</div>
                               <div class="product-point"><div class="gsquare"></div>Cylinder</div>
                               <div class="product-point"><div class="gsquare"></div>Forged Pipe</div>
                               <div class="product-point"><div class="gsquare"></div>Body Flange</div>
                               <div class="product-point"><div class="gsquare"></div>Girth Flange</div>
                               <div class="product-point"><div class="gsquare"></div>Other Custom Forgings</div>
                           </div>
                           <div class="content-box-row cbr2" >
                               <p class="content-box-row-header">Standards</p>
                               <div class="product-point"><div class="gsquare"></div>ASTM</div>
                               <div class="product-point"><div class="gsquare"></div>ASME</div>
                               <div class="product-point"><div class="gsquare"></div>JIS</div>
                           </div>
                           <div class="clearfix"></div>
                           <div class="content-box-row cbr3">
                               <p class="content-box-row-header">Materials</p>
                               <div class="product-point"><div class="gsquare"></div>Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Low Temp Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>High Yield Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Stainless Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Alloy Steel</div>
                           </div>
                           <div class="content-box-row cbr4">
                               <p class="content-box-row-header">Production Range</p>
                               <div class="product-point"><div class="gsquare"></div>B16.5 1/2"-24"</div>
                               <div class="product-point"><div class="gsquare"></div>B16.47 SERIES A &amp; B 26"-60"</div>
                           </div>
                       </div>
                   </div>
               </div> -->
 
               <!-- Heads Section -->
               <!-- <div class="products-content-right" style="float:left;" v-if="showHeads">
                   <div class="products-gallery" >
                       <div class="products-car">
                           <div id="heads-car" class="carousel carousel-fade" data-ride="carousel" style="width: 100%; height: 100%; display: block; margin: 0 0 8% 4%; float: right;">
                               <ol class="carousel-indicators">
                                   <li data-target="#heads-car" data-slide-to="0" class="active"></li>
                                   <li data-target="#heads-car" data-slide-to="1"></li>
                               </ol>
                               <div class="carousel-inner">
                                   <div class="carousel-item active">
                                       <img class="d-block w-100" src="../../public/images/HeadsP1.jpg" alt="First slide">
                                   </div>
                                   <div class="carousel-item">
                                       <img class="d-block w-100" src="../../public/images/HeadsP2.jpg" alt="Second slide">
                                   </div>
                               </div>
                               <a class="carousel-control-prev" href="#heads-car" role="button" data-slide="prev">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-back-circle.svg" style="width: 30px;"></span>
                                   <span class="sr-only">Previous</span>
                               </a>
                               <a class="carousel-control-next" href="#heads-car" role="button" data-slide="next">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-forward-circle.svg" style="width: 30px;"></span>
                                   <span class="sr-only">Next</span>
                               </a>
                           </div>
                           <div class="clearfix"></div>
                       </div>
                   </div>
                   <div class="content-info">
                       <h2 class="product-content-title">Heads</h2>
                       <div class="content-info-box">
                           <div class="content-box-row">
                               <p class="content-box-row-header">Heads</p>
                               <div class="product-point"><div class="gsquare"></div>Elbow</div>
                               <div class="product-point"><div class="gsquare"></div>Tee</div>
                               <div class="product-point"><div class="gsquare"></div>Reducer</div>
                               <div class="product-point"><div class="gsquare"></div>Cap</div>
                               <div class="product-point"><div class="gsquare"></div>Stub-End</div>
                               <div class="product-point"><div class="gsquare"></div>Bends (3D/5D/8D)</div>
                           </div>
                           <div class="content-box-row cbr2">
                               <p class="content-box-row-header">Standards</p>
                               <div class="product-point"><div class="gsquare"></div>ANSI B16.25</div>
                               <div class="product-point"><div class="gsquare"></div>MSS SP-42, 75</div>
                               <div class="product-point"><div class="gsquare"></div>JIS</div>
                               <div class="product-point"><div class="gsquare"></div>BS</div>
                           </div>
                           <div class="clearfix"></div>
                           <div class="content-box-row cbr3">
                               <p class="content-box-row-header">Materials</p>
                               <div class="product-point"><div class="gsquare"></div>Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Low Temp Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>High Yield Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Stainless Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Chrome Alloy</div>
                               <div class="product-point"><div class="gsquare"></div>Duplex</div>
                           </div>
                           <div class="content-box-row cbr4">
                               <p class="content-box-row-header">Production Range</p>
                               <div class="product-point"><div class="gsquare"></div>2” ˜ 24” (Seamless)</div>
                               <div class="product-point"><div class="gsquare"></div>26” ˜ 60” (Welded)</div>
                               <div class="product-point"><div class="gsquare"></div>64” ˜ 120” (Welded)</div>
                           </div>
                       </div>
                   </div>
               </div> -->
 
               <!-- Boltings Section -->
               <!-- <div class="products-content-right" style="float: left;" v-if="showBoltings">
                   <div class="products-gallery" >
                       <div class="products-car">
                           <div id="boltings-car" class="carousel carousel-fade" data-ride="carousel" style="width: 100%; height: 100%; display: block; margin: 0 0 8% 4%; float: right;">
                               <ol class="carousel-indicators">
                                   <li data-target="#boltings-car" data-slide-to="0" class="active"></li>
                                   <li data-target="#boltings-car" data-slide-to="1"></li>
                               </ol>
                               <div class="carousel-inner">
                                   <div class="carousel-item active">
                                       <img class="d-block w-100" src="../../public/images/BoltingsP1.jpg" alt="First slide">
                                   </div>
                                   <div class="carousel-item">
                                       <img class="d-block w-100" src="../../public/images/BoltingsP2.jpg" alt="Second slide">
                                   </div>
                               </div>
                               <a class="carousel-control-prev" href="#boltings-car" role="button" data-slide="prev">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-back-circle.svg" style="width: 30px;"></span>
                                   <span class="sr-only">Previous</span>
                               </a>
                               <a class="carousel-control-next" href="#boltings-car" role="button" data-slide="next">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-forward-circle.svg" style="width: 30px;"></span>
                                   <span class="sr-only">Next</span>
                               </a>
                           </div>
                           <div class="clearfix"></div>
                       </div>
                   </div>
                   <div class="content-info">
                       <h2 class="product-content-title">Boltings</h2>
                       <div class="content-info-box">
                           <div class="content-box-row">
                               <p class="content-box-row-header">Boltings</p>
                               <div class="product-point"><div class="gsquare"></div>Elbow</div>
                               <div class="product-point"><div class="gsquare"></div>Tee</div>
                               <div class="product-point"><div class="gsquare"></div>Reducer</div>
                               <div class="product-point"><div class="gsquare"></div>Cap</div>
                               <div class="product-point"><div class="gsquare"></div>Stub-End</div>
                               <div class="product-point"><div class="gsquare"></div>Bends (3D/5D/8D)</div>
                           </div>
                           <div class="content-box-row cbr2">
                               <p class="content-box-row-header">Standards</p>
                               <div class="product-point"><div class="gsquare"></div>ANSI B16.25</div>
                               <div class="product-point"><div class="gsquare"></div>MSS SP-42, 75</div>
                               <div class="product-point"><div class="gsquare"></div>JIS</div>
                               <div class="product-point"><div class="gsquare"></div>BS</div>
                           </div>
                           <div class="clearfix"></div>
                           <div class="content-box-row cbr3">
                               <p class="content-box-row-header">Materials</p>
                               <div class="product-point"><div class="gsquare"></div>Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Low Temp Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>High Yield Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Stainless Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Chrome Alloy</div>
                               <div class="product-point"><div class="gsquare"></div>Duplex</div>
                           </div>
                           <div class="content-box-row cbr4">
                               <p class="content-box-row-header">Production Range</p>
                               <div class="product-point"><div class="gsquare"></div>2” ˜ 24” (Seamless)</div>
                               <div class="product-point"><div class="gsquare"></div>26” ˜ 60” (Welded)</div>
                               <div class="product-point"><div class="gsquare"></div>64” ˜ 120” (Welded)</div>
                           </div>
                       </div>
                   </div>
               </div> -->
 
               <!-- Tubesheet Section -->
               <!-- <div class="products-content-right" style="float: left;" v-if="showTubesheets">
                   <div class="products-gallery" >
                       <div class="products-car">
                           <div id="forgings-car" class="carousel carousel-fade" data-ride="carousel" style="width: 100%; height: 100%; display: block; margin: 0 0 8% 4%; float: right;">
                               <ol class="carousel-indicators">
                                   <li data-target="#forgings-car" data-slide-to="0" class="active"></li>
                                   <li data-target="#forgings-car" data-slide-to="1"></li>
                               </ol>
                               <div class="carousel-inner">
                                   <div class="carousel-item active">
                                       <img class="d-block w-100" src="../../public/images/TubesheetP1.jpg" alt="First slide">
                                   </div>
                                   <div class="carousel-item">
                                       <img class="d-block w-100" src="../../public/images/TubesheetP2.jpg" alt="Second slide">
                                   </div>
                               </div>
                               <a class="carousel-control-prev" href="#forgings-car" role="button" data-slide="prev">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-back-circle.svg" style="width: 30px;"></span>
                                   <span class="sr-only">Previous</span>
                               </a>
                               <a class="carousel-control-next" href="#forgings-car" role="button" data-slide="next">
                                   <span class="carousel-control-next" style="margin:auto;display:contents" aria-hidden="true"><img src="../../public/images/chevron-forward-circle.svg" style="width: 30px;"></span>
                                   <span class="sr-only">Next</span>
                               </a>
                           </div>
                           <div class="clearfix"></div>
                       </div>
                   </div>
                   <div class="content-info">
                       <h2 class="product-content-title">Tubesheets</h2>
                       <div class="content-info-box">
                           <div class="content-box-row">
                               <p class="content-box-row-header">Tubesheets</p>
                               <div class="product-point"><div class="gsquare"></div>Tube Sheet</div>
                               <div class="product-point"><div class="gsquare"></div>Nozzle Neck</div>
                               <div class="product-point"><div class="gsquare"></div>Shaft</div>
                               <div class="product-point"><div class="gsquare"></div>Piston Rod</div>
                               <div class="product-point"><div class="gsquare"></div>Cylinder</div>
                               <div class="product-point"><div class="gsquare"></div>Forged Pipe</div>
                               <div class="product-point"><div class="gsquare"></div>Body Flange</div>
                               <div class="product-point"><div class="gsquare"></div>Girth Flange</div>
                               <div class="product-point"><div class="gsquare"></div>Other Custom Forgings</div>
                           </div>
                           <div class="content-box-row cbr2" >
                               <p class="content-box-row-header">Standards</p>
                               <div class="product-point"><div class="gsquare"></div>ASTM</div>
                               <div class="product-point"><div class="gsquare"></div>ASME</div>
                               <div class="product-point"><div class="gsquare"></div>JIS</div>
                           </div>
                           <div class="clearfix"></div>
                           <div class="content-box-row cbr3">
                               <p class="content-box-row-header">Materials</p>
                               <div class="product-point"><div class="gsquare"></div>Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Low Temp Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>High Yield Carbon Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Stainless Steel</div>
                               <div class="product-point"><div class="gsquare"></div>Alloy Steel</div>
                           </div>
                           <div class="content-box-row cbr4">
                               <p class="content-box-row-header">Production Range</p>
                               <div class="product-point"><div class="gsquare"></div>B16.5 1/2"-24"</div>
                               <div class="product-point"><div class="gsquare"></div>B16.47 SERIES A &amp; B 26"-60"</div>
                           </div>
                       </div>
                   </div>
               </div> -->
 
               <!-- Product Gallery Section -->
               <!-- <div class="products-content-right products-gallery-section" v-if="showGallery">
                   <h2 class="product-content-title">Product Gallery</h2>
                   <div role="tablist">
                       <b-card no-body class="mb-1 asm" @click="PGallFittings()">
                               <b-button block v-b-toggle.accordion-1 variant="#004884" class="accordion-tab" v-bind:class="{'tab-select': gallFittings}">
                                   <p>Fittings</p>
                                   <svg class="btn-svg" height="48" width="48" xmlns="http://www.w3.org/2000/svg" v-bind:class="{'sel-btn-svg': gallFittings}">
                                       <path d="m 15 19 l 9 9 l 9 -9 l -18 0 z"/>
                                       <path d="M0-.25h24v24H0z" fill="none"/>
                                   </svg>
                               </b-button>
                           <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                               <b-card-body>
                                   <b-card-text class="accordion-text" style="margin-top: -15px;">
                                       <div class="product-gallery-row">
                                           <div class="product-gallery-img" v-for="(record, i) in fFittings" :key="record.id">
                                               <lightbox :thumbnail="record.fields.Image[0].url" :images="fFittings" :name="fFittings" :num="i"/>
                                               <div class="product-gallery-row-title">{{ record.fields.Product }}</div>
                                           </div>
                                       </div>
                                   </b-card-text>
                               </b-card-body>
                           </b-collapse>
                       </b-card>
 
                       <b-card no-body class="mb-1 asm" @click="PGallFlanges()">
                           <b-button block v-b-toggle.accordion-2 variant="#004884" class="accordion-tab" v-bind:class="{'tab-select': gallFlanges}">
                               <p>Flanges</p>
                               <svg class="btn-svg" height="48" width="48" xmlns="http://www.w3.org/2000/svg" v-bind:class="{'sel-btn-svg': gallFlanges}">
                                   <path d="m 15 19 l 9 9 l 9 -9 l -18 0 z"/>
                                   <path d="M0-.25h24v24H0z" fill="none"/>
                               </svg>
                           </b-button>
                           <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                               <b-card-body>
                                   <b-card-text class="accordion-text" style="margin-top: -15px;">
                                       <div class="product-gallery-row">
                                           <div class="product-gallery-img" v-for="(record, i)  in fFlanges" :key="record.id">
                                               <lightbox :thumbnail="record.fields.Image[0].url" :images="fFlanges" :name="fFlanges" :num="i"/>
                                               <div class="product-gallery-row-title">{{ record.fields.Product }}</div>
                                           </div>
                                       </div>
                                   </b-card-text>
                               </b-card-body>
                           </b-collapse>
                       </b-card>
 
                       <b-card no-body class="mb-1 asm" @click="PGallForgings()">
                           <b-button block v-b-toggle.accordion-3 variant="#004884" class="accordion-tab" v-bind:class="{'tab-select': gallForgings}">
                               <p>Forgings (Custom Made)</p>
                               <svg class="btn-svg" height="48" width="48" xmlns="http://www.w3.org/2000/svg" v-bind:class="{'sel-btn-svg': gallForgings}">
                                   <path d="m 15 19 l 9 9 l 9 -9 l -18 0 z"/>
                                   <path d="M0-.25h24v24H0z" fill="none"/>
                               </svg>
                           </b-button>
                           <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                               <b-card-body>
                                   <b-card-text class="accordion-text" style="margin-top: -15px;">
                                        <div class="product-gallery-row">
                                           <div class="product-gallery-img" v-for="(record, i) in fForgings" :key="record.id">
                                               <lightbox :thumbnail="record.fields.Image[0].url" :images="fForgings" :name="fForgings" :num="i"/>
                                               <div class="product-gallery-row-title">{{ record.fields.Product }}</div>
                                           </div>
                                       </div>
                                   </b-card-text>
                               </b-card-body>
                           </b-collapse>
                       </b-card>
 
                       <b-card no-body class="mb-1 asm" @click="PGallHeads()">
                           <b-button block v-b-toggle.accordion-4 variant="#004884" class="accordion-tab" v-bind:class="{'tab-select': gallHeads}">
                               <p>Heads</p>
                               <svg class="btn-svg" height="48" width="48" xmlns="http://www.w3.org/2000/svg" v-bind:class="{'sel-btn-svg': gallHeads}">
                                   <path d="m 15 19 l 9 9 l 9 -9 l -18 0 z"/>
                                   <path d="M0-.25h24v24H0z" fill="none"/>
                               </svg>   
                           </b-button>
                           <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                               <b-card-body>
                                   <b-card-text class="accordion-text" style="margin-top: -15px;">
                                       <div class="product-gallery-row">
                                           <div class="product-gallery-img" v-for="(record, i) in fHeads" :key="record.id">
                                               <lightbox :thumbnail="record.fields.Image[0].url" :images="fHeads" :name="fHeads" :num="i"/>
                                               <div class="product-gallery-row-title">{{ record.fields.Product }}</div>
                                           </div>
                                       </div>
                                   </b-card-text>
                               </b-card-body>
                           </b-collapse>
                       </b-card>
 
                       <b-card no-body class="mb-1 asm" @click="PGallBoltings()">
                           <b-button block v-b-toggle.accordion-5 variant="#004884" class="accordion-tab" v-bind:class="{'tab-select': gallBoltings}">
                               <p>Boltings</p>
                               <svg class="btn-svg" height="48" width="48" xmlns="http://www.w3.org/2000/svg" v-bind:class="{'sel-btn-svg': gallBoltings}">
                                   <path d="m 15 19 l 9 9 l 9 -9 l -18 0 z"/>
                                   <path d="M0-.25h24v24H0z" fill="none"/>
                               </svg>
                           </b-button>
                           <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                               <b-card-body>
                                   <b-card-text class="accordion-text" style="margin-top: -15px;">
                                       <div class="product-gallery-row">
                                           <div class="product-gallery-img" v-for="(record, i) in fBoltings" :key="record.id">
                                               <lightbox :thumbnail="record.fields.Image[0].url" :images="fBoltings" :name="fBoltings" :num="i"/>
                                               <div class="product-gallery-row-title">{{ record.fields.Product }}</div>
                                           </div>
                                       </div>
                                   </b-card-text>
                               </b-card-body>
                           </b-collapse>
                       </b-card>
 
                       <b-card no-body class="mb-1 asm" @click="PGallTubesheets()">
                               <b-button block v-b-toggle.accordion-6 variant="#004884" class="accordion-tab" v-bind:class="{'tab-select': gallTubesheets}">
                                   <p>Tubesheets</p>
                                   <svg class="btn-svg" height="48" width="48" xmlns="http://www.w3.org/2000/svg" v-bind:class="{'sel-btn-svg': gallTubesheets}">
                                       <path d="m 15 19 l 9 9 l 9 -9 l -18 0 z"/>
                                       <path d="M0-.25h24v24H0z" fill="none"/>
                                   </svg>
                               </b-button>
                           <b-collapse id="accordion-6" visible accordion="my-accordion" role="tabpanel">
                               <b-card-body>
                                   <b-card-text class="accordion-text" style="margin-top: -15px;">
                                       <div class="product-gallery-row">
                                           <div class="product-gallery-img" v-for="(record, i) in fTubesheets" :key="record.id">
                                               <lightbox :thumbnail="record.fields.Image[0].url" :images="fTubesheets" :name="fTubesheets" :num="i"/>
                                               <div class="product-gallery-row-title">{{ record.fields.Product }}</div>
                                           </div>
                                       </div>
                                   </b-card-text>
                               </b-card-body>
                           </b-collapse>
                       </b-card>
                   </div>
               </div> -->
           </div>
       </div>
   </div>
</template>
 
<script>
import Lightbox from '../components/Lightbox.vue';
import axios from 'axios';
 
export default {
   name: 'Products',
   components: { Lightbox },
   data() {
       return {
           // id: this.$route.params.id,
           apiUrl: 'https://api.airtable.com/v0/',
        //    apiKey: 'keymCQVDTgGll1UCB', // Old Key
           apiKey: 'patuMyb6fwFAe9THH.ca32f9390ac6213308df3a99dc6fb185f635fe2d42d8020693e93ec6273f6d3f', // New Key
           base: 'appvYrkhR0QLHGIgm/Products/?view=Grid+view',
           records: [],
           showFittings: false,
           showFlanges: false,
           showForgings: false,
           showHeads: false,
           showBoltings: false,
           showTubesheets: false,
           showGallery: false,
           gallFittings: false,
           gallFlanges: true,
           gallForgings: false,
           gallHeads: false,
           gallBoltings: false,
           gallTubesheets: false,
       }
   },
   computed: {
       fFittings() {
           return this.records.filter(record => record.fields.Type === 'Fittings');
       },
       fFlanges() {
           return this.records.filter(record => record.fields.Type === 'Flanges')
       },
       fForgings() {
           return this.records.filter(record => record.fields.Type === 'Forgings')
       },
       fHeads() {
           return this.records.filter(record => record.fields.Type === 'Heads')
       },
       fBoltings() {
           return this.records.filter(record => record.fields.Type === 'Boltings')
       },
       fTubesheets() {
           return this.records.filter(record => record.fields.Type === 'Tubesheets')
       }
   },
   mounted() {
       this.getData();
   },
   methods: {
       getData() {
           axios({
               url: this.apiUrl + this.base,
               headers: {
                   'Authorization': `Bearer ${this.apiKey}`
               }
           }).then((res) => {
               this.records = res.data.records;
           });
       },
       PGallFittings() {
           this.$data.gallFittings = !this.$data.gallFittings;
           this.$data.gallFlanges = false;
           this.$data.gallForgings = false;
           this.$data.gallHeads = false;
           this.$data.gallBoltings = false;
           this.$data.gallTubesheets = false;
       },
       PGallFlanges() {
           this.$data.gallFittings = false;
           this.$data.gallFlanges = !this.$data.gallFlanges;
           this.$data.gallForgings = false;
           this.$data.gallHeads = false;
           this.$data.gallBoltings = false;
           this.$data.gallTubesheets = false;
       },
       PGallForgings() {
           this.$data.gallFittings = false;
           this.$data.gallFlanges = false;
           this.$data.gallForgings = !this.$data.gallForgings;
           this.$data.gallHeads = false;
           this.$data.gallBoltings = false;
           this.$data.gallTubesheets = false;
       },
       PGallHeads() {
           this.$data.gallFittings = false;
           this.$data.gallFlanges = false;
           this.$data.gallForgings = false;
           this.$data.gallHeads = !this.$data.gallHeads;
           this.$data.gallBoltings = false;
           this.$data.gallTubesheets = false;
       },
       PGallBoltings() {
           this.$data.gallFittings = false;
           this.$data.gallFlanges = false;
           this.$data.gallForgings = false;
           this.$data.gallHeads = false;
           this.$data.gallBoltings = !this.$data.gallBoltings;
           this.$data.gallTubesheets = false;
       },
       PGallTubesheets() {
           this.$data.gallFittings = false;
           this.$data.gallFlanges = false;
           this.$data.gallForgings = false;
           this.$data.gallHeads = false;
           this.$data.gallBoltings = false;
           this.$data.gallTubesheets = !this.$data.gallTubesheets;
       },
       ShowFittings() {
           this.$data.showFittings = true;
           this.$data.showFlanges = false;
           this.$data.showForgings = false;
           this.$data.showHeads = false;
           this.$data.showBoltings = false;
           this.$data.showTubesheets = false;
           this.$data.showGallery = false;
       },
       ShowFlanges() {
           this.$data.showFittings = false;
           this.$data.showFlanges = true;
           this.$data.showForgings = false;
           this.$data.showHeads = false;
           this.$data.showBoltings = false;
           this.$data.showTubesheets = false;
           this.$data.showGallery = false;
       },
       ShowForgings() {
           this.$data.showFittings = false;
           this.$data.showFlanges = false;
           this.$data.showForgings = true;
           this.$data.showHeads = false;
           this.$data.showBoltings = false;
           this.$data.showTubesheets = false;
           this.$data.showGallery = false;
       },
       ShowHeads() {
           this.$data.showFittings = false;
           this.$data.showFlanges = false;
           this.$data.showForgings = false;
           this.$data.showHeads = true;
           this.$data.showBoltings = false;
           this.$data.showTubesheets = false;
           this.$data.showGallery = false;
       },
       ShowBoltings() {
           this.$data.showFittings = false;
           this.$data.showFlanges = false;
           this.$data.showForgings = false;
           this.$data.showHeads = false;
           this.$data.showBoltings = true;
           this.$data.showTubesheets = false;
           this.$data.showGallery = false;
       },
       ShowTubesheets() {
           this.$data.showFittings = false;
           this.$data.showFlanges = false;
           this.$data.showForgings = false;
           this.$data.showHeads = false;
           this.$data.showBoltings = false;
           this.$data.showTubesheets = true;
           this.$data.showGallery = false;
       },
       ShowGallery() {
           this.$data.showFittings = false;
           this.$data.showFlanges = false;
           this.$data.showForgings = false;
           this.$data.showHeads = false;
           this.$data.showBoltings = false;
           this.$data.showTubesheets = false;
           this.$data.showGallery = true;
       },
   }
}
</script>
 
<style scoped>
   .products-car {
       width: 70%;
       min-width: 500px;
   }
   .carousel-indicators {
       margin-top: 600px;
       bottom: -35px;
   }
   .carousel-indicators li {
       width: 25px;
       height: 4px;
       background-color: #adadad;
   }
   .carousel-indicators .active {
       background-color: #00C5BC;
       width: 36px;
   }
   * {
       box-sizing: border-box;
       margin: 0;
       padding: 0;
       font-family: 'Forma DJR Micro', sans-serif;
   }
   .cont {
       padding: 0 7% 0 7%;
   }
   .management-services-header {
       background: url("../../public/images/products.jpg");
       background-size: cover;
       background-repeat: no-repeat;
       width: 100%;
       position: relative;
   }
   #ms-header-bg {
       background-image:url('../../public/images/products.jpg');
       background-size: cover;
       background-repeat:no-repeat;
       width:100%;
       height:0;
       padding-top:35%;
       position:relative;
       visibility: hidden;
   }
   #header-gDash {
       width:52%;
       /* max-width:820px; */
       height:3px;
       background:#00C5BC;
       position:absolute;
       bottom:17%;
   }
   .gsquare {
       margin: 0px 12px 0px 25px;
       background: rgb(0, 197, 188);
       width: 10px;
       height: 10px;
       display: inline-block;
   }
   .product-point {
       margin-bottom: 10px;
       display: flex;
   }
   .pp-inner {
       height: 100%;
   }
   .section-select {
       width:100%;
       padding:12px 15px;
       text-align:left;
       border-radius:0px;
       background:none;
       border:3px solid #707070;
       color:black;
       font-size:18px;
       position: relative;
   }
   .section-select:active {
       background: none;
       background-color: none;
   }
   .dropdown-menu {
       transform: translate3d(0px, 56px, 0px) !important;
   }
   .header-text, .mobile-header-text {
       position: absolute;
       top: 0;
       padding: 110px 4% 0 0;
       width: 100%;
   }
   .header-text p {
       color: white;
       font-size: clamp(35px, 3.3vw, 65px);
       line-height: 1.3em;
       font-weight: bold;
       text-align: right;
       text-shadow: 6px 10px 22px black;
   }
   .product-content-title {
       font-size: 40px;
       line-height: 50px;
       font-weight: bold;
       margin-bottom: 42px;
   }
   .product-content1 {
       height: auto;
       margin-top: 6%;
       display: flex;
   }
   .products-page-sidenav {
       margin-left: 7%;
       width: 20vw;
       min-width: 300px;
       max-width: 340px;
       height: 408px;
       float: left;
       margin-right: 5%;
   }
   .products-page-sidenav p {
       font-size: 17px;
       width: 100%;
       height: 60px;
       padding: 18px 0 0 21px;
       display: block;
       cursor: pointer;
   }
   .content-info {
       height: 760px;
       margin-top: 40px;
       width: 100%;
       display: flex;
       justify-content: space-around;
   }
   .content-info-box {
        display: flex;
        justify-content: space-around;
        margin-top: 15px;
        flex-direction: row;
        flex-wrap: wrap;
   }
   .content-box-row {
       width: 23.7%;
       min-width: 150px;
       max-width: 335px;
       height: 490px;
       border: 1.3px solid #707070;
   }
   .cbr2 {
       margin-left: 25px;
   }
   .cbr3 {
       margin-top: 25px;
   }
   .cbr4 {
       margin: 25px 0 0 25px;
   }
   .products-content-right {
       width: 100%;
   }
   .content-box-row-header {
       margin: 15px 25px;
       font-size: 22px;
       font-weight: bold;
       padding-bottom: 7px;
       border-bottom: 1.3px solid #707070;  
   }
   .active-tab {
       background: #E3E3E3;
       border-left: 10px solid #004884;
       padding: 5.5% 0 0 5.5%;
       font-weight: bold;
   }
   .asm {
       border: none;
       outline: none;
       background-color: none;
       border-bottom: none;
   }
   .accordion-tab {
       background: #E3E3E3;
       border: none;
       box-shadow: 3px 5px 10px #0000001A;
       border-radius: 3px;
       height: 70px;
       text-align: left;
       padding-left: 22px;
       color: black;
       font-size: 18px;
       font-weight: bold;
       margin-bottom: 15px;
       display: flex;
       flex-direction: row;
       justify-content: space-between;
       align-items: center;
   }
   .accordion-tab:active {
       color: white;
       background: #004884;
       background-color: #004884;
   }
   .accordion-text {
       margin-bottom: 15px;
   }
   .products-gallery-section {
       /* margin-right: 7%; */
       height: auto;
       /* float: left; */
       width: 100%;
   }
   .product-gallery-img {
       width: 23.7%;
       position: relative;
       margin: 0.6%;
       min-height: 230px;
       max-height: 240px;
       overflow: hidden;
       display: flex;
       flex-wrap: nowrap;
   }
   .product-gallery-row-title {
       width: 100%;
       height: 40px;
       padding: 10px 18px;
       position: absolute;
       background: #00C5BC;
       bottom: 0;
       color: white;
   }
   .product-gallery-row {
       display: flex;
       justify-content: flex-start;
       margin-top: 1.5%;
       flex-wrap: wrap;
   }
   .product-gallery-img img {
       width: 100%;
       /* height: auto; */
       object-fit: cover;
       min-height: 100%;
   }
   .mobile-header-text p {
       color: white;
       font-size: clamp(20px, 12vw, 50px);
       line-height: 1.3em;
       font-weight: bold;
       text-align: right;
       text-shadow: 6px 10px 22px black;
   }
   .mobile-img-header {
       background: url("../../public/images/products.jpg") bottom;
       background-size: cover;
       background-repeat: no-repeat;
       width: 100%;
       position: relative;
       display: none;
   }
   #mobile-line {
       width: 100%;
       background: #707070;
       height: 2px;
       display: none;
       margin: 25px 0 35px 0;
   }
   .dropdown {
       display: none;
       width:100%;
       margin-bottom:25px;
   }
   .dropdown-item:active {
       background: #004884;
   }
   .btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show >.btn-secondary.dropdown-toggle {
       color: black !important;
       background-color: white !important;
   }
   .tab-select {
       background: #004884 !important;
       color: white !important;
   }
   .btn-svg {
       fill: #4D4D4D;
       transition: 0.15s;
   }
   .sel-btn-svg {
       fill: white;
       transform: rotate(180deg);
       transition: 0.15s;
   }
   @media screen and (max-width: 1260px) {
       #header-gDash {
           width:47%;
       }
       .products-gallery-section {
           width: 100%;
       }
   }
   @media screen and (max-width: 1100px) {
       #header-gDash {
           width:43%;
       }
   }
   @media screen and (max-width: 1000px) {
       #header-gDash {
           width:38%;
       }
       .products-page-sidenav {
           width: 100%;
           float: unset;
           min-width: unset;
           max-width: unset;
           margin-left: 0;
           height: auto;
       }
       .products-page-sidenav p {
           font-size: 18px;
           width: 100%;
           height: 55px;
           padding: 16px 0 0 19px;
           display: block;
           cursor: pointer;
       }
       .dropdown {
           display: block;
       }
       .products-page-sidenav {
           display: none;
       }
       .product-content1 {
           height: auto;
           margin: 7% 0;
           flex-direction: column;
       }
       #mobile-line {
           display: block;
       }
       .cbr2, .cbr3, .cbr4 {
           margin:0;
       }
       .content-box-row {
           float:unset !important;
           width: 48.6%;
           max-width: 430px;
           height: 500px;
           margin-top: 25px;
       }
       .content-info {
           width: 100%;
           height: auto;
           margin-top: 10%;
       }
       .products-gallery-section {
           width: 100%;
       }
       .products-content-right {
           /* float: unset !important; */
           width: 100%;
       }
       .products-car {
           min-width: 100%;
       }
       .product-gallery-img {
            width: 32%;
        }
   }
   @media screen and (max-width: 900px) {
       .cont {
           padding: 0 11% 0 11%;
       }
       .management-services-header {
           display: none;
       }
       .mobile-img-header {
           display: block;
       }
       .product-content1 {
           margin-bottom: 50px;
       }
       .header-text, .mobile-header-text {
            padding: 100px 4% 0 0;
        }
        .mobile-header-text p {
            font-size: clamp(20px,7vw,40px);
        }
   }
   @media screen and (max-width: 500px) {
       .cont {
           padding: 0 20px 0 20px;
       }
       .mobile-img-header {
           max-height:335px;
       }
       #mobile-about-header {
           font-size: 24px;
           line-height: unset;
       }
       .mobile-header-text p {
           font-size: clamp(25px,6.4vw,35px);
       }
       .product-content1 {
           margin: 7% 0px;
       }
       .product-gallery-row {
           flex-direction: column;
       }
       .product-gallery-img {
           width: 100%;
           margin: 0;
           margin-top: 25px;
       }
       .content-box-row {
           width: 100%;
           max-width: unset;
           height: 490px;
       }
   }
   @media screen and (max-width: 335px) {
       .mobile-header-text p {
            font-size: 24px;
            line-height: 1.25em;
        }
   }
   /* @media screen and (max-width: 290px) {
       .mobile-img-header {
           margin-top:-30%;
       }
   } */
</style>

